import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// =============================================================================
//  Copyright : 2019 semantics GmbH
//  Date      : $Date: 2026-02-07 12:44:20 +0100 (Sat, 07 Feb 2026) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 160442 $
//  Purpose   : register font graphics
//  Usage:
//    <Label icon={vicon('cog', {color: 'red', loading: true})} />
//    or after registered in ICON_NAMES
//    <Label icon={Icons.cog} />
//    or as react component
//    <VIcon name="warehouse" style={{color: 'red}} />
// =============================================================================
// ---Third-party imports
import React from 'react';
import { Icon } from 'semantic-ui-react';
import { size, dict, isArray, isObject } from 'ldash';
// ---Local imports
import './generated/vl.font.css';
// assemble icon list manually
// this is not needed for access via vicon() or <VIcon/> but for access via Icons.MY_NAME
// the list is also emitted as an asset: vl-icons.codepoints.js
// XXX: md_* should be injected on itypes loaded
const ICON_NAMES = [
    'analytics',
    'baby',
    'birth',
    'book',
    'bookmark',
    'bot',
    'box_empty',
    'box',
    'bug',
    'calendar_outline',
    'capsule_delta',
    'certificate',
    'chart_bar_outline',
    'chart_bar',
    'chevron_down',
    'chevron_left_end',
    'chevron_left',
    'chevron_right_end',
    'chevron_right',
    'chevron_up',
    'clipboard_capsule',
    'clipboard_check',
    'clipboard_outline',
    'close',
    'cog',
    'cogs',
    'collection',
    'configure',
    'connectors_autor',
    'connectors_geo',
    'connectors_subject',
    'connectors_title',
    'copy_outline',
    'couple',
    'cut',
    'database',
    'death',
    'debug',
    'dnb',
    'domain_archiveCollection',
    'domain_estateCollection',
    'domain_autograph',
    'domain_domain_folder',
    'domain_domain',
    'domain_eadArchiveCollection',
    'domain_epflicht',
    'domain_esa',
    'domain_externalStock',
    'domain_kalliopeArchiveCollection',
    'domain_mandant',
    'domain_manuscript',
    'domain_museumCollection',
    'domain_music',
    'domain_oaPeriodical',
    'domain_oaPeriodicals',
    'domain_pubserv',
    'domain_readingRoom',
    'domain_retro',
    'domain_retroNewspaper',
    'domain_retroPeriodicals',
    'domain_root',
    'download',
    'edit_outline',
    'envelope_outline',
    'esperanto',
    'eye',
    'feather-pen',
    'feather',
    'fingerprint',
    'folder_open_outline',
    'folder_outline',
    'globe',
    'glossary',
    'gnd',
    'help',
    'history',
    'import',
    'info',
    'jobs',
    'key',
    'lab',
    'letter',
    'linewrap',
    'link',
    'list',
    'lock_open',
    'lock',
    'md_act',
    'md_archive_box',
    'md_article',
    'md_book',
    'md_bundle',
    'md_cartographic',
    'md_codex',
    'md_collection_document',
    'md_collection_of_illustrations',
    'md_conferenceObject',
    'md_contribution',
    'md_description',
    'md_document',
    'md_ebook',
    'md_ejournal',
    'md_fulltome',
    'md_handwritten',
    'md_illustration_document',
    'md_inventory',
    'md_journal_additional',
    'md_journal_issue',
    'md_journal_month',
    'md_journal_volume',
    'md_journal',
    'md_letter_manual',
    'md_letter',
    'md_mixed_material',
    'md_moving_image',
    'md_multivolumework',
    'md_music_additional_source',
    'md_music_autograph',
    'md_music_copy',
    'md_music_handwritten_libretto',
    'md_music_handwritten_theoretikum',
    'md_music_partial_autograph',
    'md_music_print',
    'md_music_printed_libretto',
    'md_music_printed_theoretikum',
    'md_music_questionable_autograph',
    'md_news',
    'md_newspaper_series',
    'md_newspaper',
    'md_notated_music',
    'md_oaArticle',
    'md_oaBachelorThesis',
    'md_oaBdArticle',
    'md_oaBdOther',
    'md_oaBook',
    'md_oaBookPart',
    'md_oaDiplom',
    'md_oaDoctoralThesis',
    'md_oaExamen',
    'md_oaHabil',
    'md_oaMasterThesis',
    'md_oaPreprint',
    'md_oaStudyThesis',
    'md_periodical',
    'md_periodicaltome',
    'md_piece_of_music',
    'md_poster',
    'md_press_comment',
    'md_record',
    'md_review',
    'md_series',
    'md_sound_recording',
    'md_still_image',
    'md_typescript',
    'md_workingPaper',
    'mouse_select',
    'move_bottom_left',
    'move_bottom_right',
    'move_top_left',
    'move_top_right',
    'overview',
    'parentNode',
    'paste_outline',
    'pencil_alternate',
    'pencil',
    'pivot_table',
    'prettyprint',
    'publication',
    'puzzle_outline',
    'reward',
    'save',
    'scidesk',
    'screenfit',
    'search',
    'server',
    'skull',
    'square',
    'structure',
    'sub_domain',
    'subject',
    'tbl_columns',
    'time',
    'titles',
    'transcript',
    'trash_alternate_outline',
    'trash',
    'undoAll',
    'unpivot_table',
    'upload',
    'user',
    'users',
    'warehouse',
    'web_archive',
    'web_collections',
    'web_date',
    'web_library',
    'web_person',
    'web_places',
    'web_subject',
    'web_title',
    'wiki',
    'wikipedia',
    'workshop',
    'world',
    'ws_add-file',
    'ws_arrow-left',
    'ws_arrow-right',
    'ws_arrowhead-left',
    'ws_arrowhead-right',
    'ws_artwork',
    'ws_chevron-left',
    'ws_chevron-right',
    'ws_edit',
    'ws_info-circle',
    'ws_link',
    'ws_redo',
    'ws_text-bold',
    'ws_text-italic',
    'ws_text-underline',
    'ws_thumbnails',
    'ws_undo',
    'wys_columns',
    'wys_comment',
    'wys_commentsForm',
    'wys_doubleUnderline',
    'wys_edit',
    'wys_footnote',
    'wys_formatStyle',
    'wys_header1',
    'wys_header2',
    'wys_header3',
    'wys_header4',
    'wys_horizontalLine',
    'wys_link',
    'wys_marginNote-left',
    'wys_marginNote-right',
    'wys_newLine',
    'wys_overlayText',
    'wys_paragraph',
    'wys_release',
    'wys_underline',
    'zip'
];
let makeIcons = (ns, names)=>dict(names.map((n)=>[
            n.replace(/ /g, '_'),
            {
                className: `${ns}icon ${ns}-${n}`
            }
        ]));
// ---Exports
// all registered icon names
export const Icons = makeIcons('v', ICON_NAMES);
let FALLBACK = 'cog';
// generic version with additional props
const genClassName = (name)=>`vicon v-${(name || FALLBACK).replace(/ /g, '_')}`;
export const vicon = (name, props)=>({
        className: genClassName(name),
        ...props
    });
export const VIcon = ({ name, style, suiFallback = true, ...props })=>{
    name = name || '';
    if (isArray(name)) {
        let [icon1, icon2, icon3] = name;
        let decode = (n)=>{
            let props = {
                style
            };
            if (isObject(n)) {
                props = {
                    ...props,
                    ...n
                };
            } else {
                props = {
                    ...props,
                    name: n
                };
            }
            if (suiFallback && !Icons[props.name.replace(/ /g, '_')]) {
                return props;
            } else {
                return {
                    ...props,
                    className: genClassName(props.name),
                    name: undefined
                };
            }
        };
        return /*#__PURE__*/ _jsxs(Icon.Group, {
            children: [
                /*#__PURE__*/ _jsx(Icon, {
                    ...decode(icon1)
                }),
                icon2 && /*#__PURE__*/ _jsx(Icon, {
                    corner: "bottom right",
                    ...decode(icon2)
                }),
                icon3 && /*#__PURE__*/ _jsx(Icon, {
                    corner: "bottom left",
                    ...decode(icon3)
                })
            ]
        });
    }
    if (suiFallback && !Icons[name.replace(/ /g, '_')]) {
        return /*#__PURE__*/ _jsx(Icon, {
            name: name,
            style: style,
            ...props
        });
    }
    return /*#__PURE__*/ _jsx(Icon, {
        className: genClassName(name),
        style: style,
        ...props
    });
};
